export const MAX_END_YEAR = new Date().getFullYear() + 25;
export const MIN_START_YEAR = 1910;
export const MONTHS = 12;
export const DAYS = 31;
export const WEEK = 7;
export const YEAR_LENGTH = 4;
export const MONTH_LENGTH = 2;
export const DAY_LENGTH = 2;
